import {CallToActionNotice, EmptyMessage} from '#/components/lands/empty-lands';
import {LoadingLands} from '#/components/lands/loading-lands';
import {PortfolioAccountContext} from '#/components/portfolio/context/portfolio-account-context';
import {PortfolioAssetsContext} from '#/components/portfolio/context/portfolio-assets-context';
import {PortfolioLandAsset} from '#/components/portfolio/subcomponents/portfolio-land-asset';
import {PortfolioNoContentContainer} from '#/components/portfolio/subcomponents/portfolio-no-content-container';
import {useSelectedLand} from '#/hooks/use-selected-land';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Land, LandAccountInfo, LandMarketInfo, TransactionPortfolioValue} from 'shareland-common';

type LandGroup = {
  land: Land;
  portfolioValue: TransactionPortfolioValue;
  landMarketInfo: LandMarketInfo;
  landAccountInfo: LandAccountInfo;
};

export const PortfolioAssets: FunctionComponent = () => {
  const {t} = useTranslation('translation');

  const {landGroups, isLoading} = useContext(PortfolioAssetsContext);

  const {isCurrentUser} = useContext(PortfolioAccountContext);
  const {data: selectedLand} = useSelectedLand();

  const landGroupsFiltered = landGroups.filter(
    (entry): entry is LandGroup => !!entry.landMarketInfo && !!entry.landAccountInfo,
  );

  const showLoading = isLoading.lands || isLoading.marketInfo || isLoading.accountInfo;
  const showEmpty = !showLoading && landGroupsFiltered.length === 0;

  if (showLoading) {
    return (
      <PortfolioNoContentContainer>
        <LoadingLands />
      </PortfolioNoContentContainer>
    );
  }

  if (showEmpty) {
    return (
      <PortfolioNoContentContainer>
        {isCurrentUser ? (
          <CallToActionNotice
            title={t('pages.portfolio.sections.assets.emptyContent.currentUser.ctaTitle')}
            subtitle={t('pages.portfolio.sections.assets.emptyContent.currentUser.ctaSubtitle')}
          />
        ) : (
          <EmptyMessage>{t('pages.portfolio.sections.assets.emptyContent.otherUser.message')}</EmptyMessage>
        )}
      </PortfolioNoContentContainer>
    );
  }

  return (
    <div className={'flex flex-col gap-4'}>
      {landGroupsFiltered.map(({land, portfolioValue, landMarketInfo, landAccountInfo}) => (
        <PortfolioLandAsset
          key={`portfolio-land-tile-${land.tokenSymbol}`}
          selected={!!selectedLand && selectedLand.id === land?.id}
          land={land}
          portfolioValue={portfolioValue}
          landMarketInfo={landMarketInfo}
          landAccountInfo={landAccountInfo}
          isCurrentUser={isCurrentUser}
        />
      ))}
    </div>
  );
};
